import * as React from 'react';

/***** COMPONENTS *****/
import { Text } from '../Text';

/***** STYLES *****/
import * as styles from './CheckboxButton.css';

/***** TYPES *****/
export interface ICheckboxButtonProps extends React.HTMLProps<HTMLInputElement> {
  dataMark?: string;
  As?: keyof JSX.IntrinsicElements;
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void;
}

/***** COMPONENT *****/
export class CheckboxButton extends React.PureComponent<ICheckboxButtonProps> {
  public render() {
    const { children, As = 'div', ...rest } = this.props;
    const {
      dataMark = 'CheckboxButton',
    } = rest;

    return (
      <label data-mark={dataMark} className={styles['checkbox']}>
        <As className={styles['handler']}>
          <input
            type="checkbox"
            className={styles['hidden_input']}
            {...rest}
          />
          <span className={styles['box']}>
          <Text>{children}</Text>
        </span>
        </As>
      </label>
    );
  }
}
